import html from "./VerifyEmailAddress.html"
import "./VerifyEmailAddress.css"

var module = angular.module("ResearchKitApplicationModule");
module.component('verifyEmailAddressDashboardComponent', {
	template: html,
	bindings: {
		"model": "<"
	},
	controller: 'verifyEmailAddressController',
	controllerAs: 'vm'
});

module.controller("verifyEmailAddressController", ["$http", "ceUrl",
	function ($http, ceUrl) {
		var vm = this;

		vm.resendVerificationEmail = function () {
			$http.post(ceUrl.make("api/PatientOpenRegistration/SendVerificationEmail"));
			vm.showResendMessage = true;
			vm.showVerifyMessage = false;
		}
	}
]);